import React from 'react';
import { motion } from 'framer-motion';

const boxColors = [
  { bg: 'linear-gradient(135deg, #FFF4B8, #FFE066)', ribbon: '#FFB700' },
  { bg: 'linear-gradient(135deg, #B8E4FF, #87CEEB)', ribbon: '#5BB8D4' },
  { bg: 'linear-gradient(135deg, #FFB8C8, #FF8FAB)', ribbon: '#E05C7E' },
  { bg: 'linear-gradient(135deg, #C8F0B8, #90D870)', ribbon: '#5AAD3A' },
  { bg: 'linear-gradient(135deg, #E8B8FF, #C87FEE)', ribbon: '#9B4FC9' },
  { bg: 'linear-gradient(135deg, #FFD4B8, #FFAA80)', ribbon: '#E07540' },
];

const GiftBox = ({ box, index, onOpen }) => {
  const colors = boxColors[index % boxColors.length];

  return (
    <motion.div
      className={`gift-box-card ${box.opened ? 'opened' : 'unopened'}`}
      onClick={() => !box.opened && onOpen(box)}
      initial={{ opacity: 0, y: 30, scale: 0.85 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{
        delay: index * 0.1,
        duration: 0.5,
        type: 'spring',
        stiffness: 200,
        damping: 20,
      }}
      whileTap={!box.opened ? { scale: 0.93 } : {}}
    >
      {box.opened && <div className="opened-badge">✓ Opened</div>}

      <div
        className="gift-wrap"
        style={{ background: colors.bg }}
      >
        <div
          style={{
            position: 'absolute',
            top: 0, bottom: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            width: '8px',
            background: 'rgba(255,255,255,0.55)',
            borderRadius: '2px',
            zIndex: 0,
          }}
        />
        <div
          style={{
            position: 'absolute',
            left: 0, right: 0,
            top: '50%',
            transform: 'translateY(-50%)',
            height: '8px',
            background: 'rgba(255,255,255,0.55)',
            borderRadius: '2px',
            zIndex: 0,
          }}
        />
        {/* Bow */}
        <div style={{
          position: 'absolute',
          top: '-6px',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 2,
          fontSize: '14px',
        }}>🎀</div>

        <span className="gift-emoji" style={{ zIndex: 1, position: 'relative' }}>
          {box.emoji}
        </span>
      </div>

      <div className="gift-box-name">{box.name}</div>
    </motion.div>
  );
};

export default GiftBox;
